<div class="wrapper">
  <h1 class="title">Вход</h1>
  <form
    class="login-form"
    [formGroup]="loginForm"
    (ngSubmit)="handelLogin()"
  >
    @for (field of loginFormFields; track $index) {
      <mat-form-field>
        <mat-label>
          {{ field.label }}
        </mat-label>
        <input
          matInput
          [type]="field.type"
          [placeholder]="field.placeholder"
          [formControlName]="field.fieldName"
        >
      </mat-form-field>
    }
    <button
      mat-flat-button
      color="primary"
      [disabled]="loginForm.invalid"
    >
      Войти
    </button>
  </form>
  <app-info-application
    [needChangelogModal]="false"
  />
</div>

